import { useEffect, useState } from "react";
import { useTermsStore } from "~/features/chat/stores/termsStore";
import { Hint } from "~/features/chat/types";

export const useReportTerms = (caseId: string) => {
  const [terms, setTerms] = useState<Array<Hint>>([]);
  const getTerms = useTermsStore((s) => s.getTerms);

  useEffect(() => {
    setTerms(getTerms(caseId));
    const unsubscribe = useTermsStore.subscribe((state) => {
      setTerms(state.getTerms(caseId));
    });
    return () => unsubscribe();
  }, [caseId, getTerms]);

  return terms;
};
